<template>
    <div class="pr-5">
        <editor-js
            :data="data.areas[0].content"
            @save="(d) => save(0, d)"
        />

        <div class="field-frame">
            <div class="columns is-gapless">
                <div class="column is-narrow">
                    <b-field>
                        <b-switch v-model="data.state"/>
                    </b-field>
                </div>
                <div class="column">
                    <b-input expanded v-model="data.option"></b-input>
                </div>
            </div>

        </div>

        <editor-js
            :data="data.areas[1].content"
            @save="(d) => save(1, d)"
        />

        <advanced-options :data="data"/>
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";
    import AdvancedOptions from "./AdvancedOptions.vue";
    import {v4 as uuidv4} from "uuid";

    export default {
        props: ['data'],
        components: {EditorJs, AdvancedOptions},
        data: function() {
            return {
                advanced: false
            };
        },
        methods: {
            addOption() {
                this.data.options.push({
                    option: ''
                });
            },
            removeOption(opt) {
                this.data.options.splice(this.data.options.indexOf(opt), 1);
            },
            save(area, data) {
                this.data.areas[area].content = data;
            }
        },
        created() {
            if (!this.data.options) {
                this.data.options = [];

                this.data.areas = [
                    {areas: 1, content: null, attributes: {}},
                    {areas: 2, content: null, attributes: {}},
                ];

                this.data.state = false;
                this.data.option = '';
                this.data.id = uuidv4();
            }
        }
    };
</script>

<style lang="scss">
    .flip-cards {
        margin: 0 1.3rem 0 1.3rem;

        .flip-card-editor {
            margin: 0.6rem 1rem 0 0;

        }

    }

</style>
